const hiddenServiceErrors = ['SERVER_ERROR'];
const noDataMessages = ['NO_VERIFICATION_DATA'];

export class NoDataError extends Error {
  constructor() {
    super('NO_VERIFICATION_DATA');
    this.name = 'NoDataError';
  }
}

export function isNoDataError(error: unknown) {
  return error instanceof NoDataError;
}

function resolveRawMessage(error: unknown) {
  if (error instanceof Error) {
    return error.message;
  }

  if (typeof error === 'string') {
    return error;
  }

  return '';
}

export function shouldTreatAsNoData(status?: number, message?: string) {
  return status === 404 && (!message || noDataMessages.includes(message));
}

export function getUserSafeServiceError(error: unknown, fallbackMessage: string) {
  const rawMessage = resolveRawMessage(error).trim();

  if (!rawMessage || hiddenServiceErrors.includes(rawMessage)) {
    return fallbackMessage;
  }

  return rawMessage;
}
